import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { getFTTBAdditionalPopupPromised } from 'pages/Internet/store/selectors/servicesSelectors';
import {
  checkServiceAdditionalUserAgreement, closeServiceAdditionalPopup,
  requestServiceAdditionalPromisedPayment,
} from 'pages/Internet/store/actions/servicesActions';
import {
  PopupButton, PopupButtonLink, PopupCheckboxBlock, PopupDescription,
  PopupPromisedTitle, PopupTrustPaymentBlock,
} from '../../../../components';

export const PromisedTitle = connect(
  (state) => ({
    children: getFTTBAdditionalPopupPromised(state).title,
    isTitle: true,
  }),
)(PopupPromisedTitle);
export const PromisedTrustPaymentSection = compose(
  connect(
    (state) => ({
      children: getFTTBAdditionalPopupPromised(state).trustPaymentName,
      shouldRender: !!getFTTBAdditionalPopupPromised(state).trustPaymentName,
    }),
  ), withRenderFlag,
)(PopupTrustPaymentBlock);
export const PromisedPaymentMethodsText = compose(
  connect(
    (state) => ({
      children: getFTTBAdditionalPopupPromised(state).paymentMethodsText,
      shouldRender: !!getFTTBAdditionalPopupPromised(state).paymentMethodsText,
    }),
  ), withRenderFlag,
)(PopupPromisedTitle);
export const PromisedWarning = compose(connect(
  (state) => ({
    children: getFTTBAdditionalPopupPromised(state).Warning.text,
    image: getFTTBAdditionalPopupPromised(state).Warning.image,
    shouldRender: !!getFTTBAdditionalPopupPromised(state).Warning.text,
  }),
), withRenderFlag)(PopupDescription);

export const PromisedAgreementCheckbox = compose(
  connect(
    (state) => ({
      children: getFTTBAdditionalPopupPromised(state).agreementText,
      isChecked: !!getFTTBAdditionalPopupPromised(state).isChecked,
      shouldRender: !!getFTTBAdditionalPopupPromised(state).agreementText,
    }), (dispatch) => ({
      onChange: ({ target: { checked } }) => dispatch(checkServiceAdditionalUserAgreement(checked)),
    }),
  ), withRenderFlag,
)(PopupCheckboxBlock);

export const SubmitButtonConnected = connect(
  (state) => ({
    children: getFTTBAdditionalPopupPromised(state).takeBtn.text,
    shouldRender: !!getFTTBAdditionalPopupPromised(state).takeBtn.text,
    isDisabled: !getFTTBAdditionalPopupPromised(state).isChecked,
  }),
  {
    onClick: requestServiceAdditionalPromisedPayment,
  },
)(PopupButton);

export const OtherPaymentButtonLinkConnected = compose(
  connect(
    (state) => ({
      url: getFTTBAdditionalPopupPromised(state).otherBtn.link,
      children: getFTTBAdditionalPopupPromised(state).otherBtn.text,
      shouldRender: !!getFTTBAdditionalPopupPromised(state).otherBtn.link,
    }),
    {
      onClick: closeServiceAdditionalPopup,
    },
  ), withRenderFlag,
)(PopupButtonLink);
